export default __webpack_public_path__ + "static/Lato-Regular-1d2ca94dfba6f8d87cfda33b32f0febc.woff";